import React, {Component} from 'react';
import locale from './locale'
import { confirm } from 'util/confirm';
import {userCan} from 'containers/__R';

import './PotentialClient.scss'

class TagsField extends Component{

  constructor(props){
    super(props)

    this.state = {
      toggledEdit: {},
      name: '',
    }

    this.toggledEdit = this.toggledEdit.bind(this)
  }

  toggledEdit(key, name){
    return () => {
      if(userCan('edit_contact_tag')){
        this.setState({
          toggledEdit: {
            [key]: this.state.toggledEdit[key] !== true,
          },
          name,
        });
      }
    }
  }

  render(){
    if (!this.props.tagList){
      return(<div />)
    }

    const {tagList, tag_id_list} = this.props
    const {toggledEdit, name} = this.state

    let tags = []
    tagList.map((tag) => {
      tags.push({id: tag.name, text: tag.name, tagId: tag.id})
    })

    return(
      <div className='tags-field-content'>
        <div className='tags-field-header'>
          <span className='tags-field-title'>{__('Tags Filter', locale)}</span>
          {/* <i className='fa icon-align-right fa-border pull-right'></i> */}
        </div>
        <div className='tags-field-container'>
          {tags.map((tag, index) => {
            return (
              <div className='tag-container' key={tag.tagId}>
                {(toggledEdit[tag.tagId] !== true) && <div>
                  <label className='control'>
                    <input
                      type='checkbox'
                      value={tag.tagId}
                      checked={tag_id_list.indexOf(tag.tagId) > -1}
                      onClick={(event) => this.props.onTagChange(event, tag.tagId)}
                    />
                    <span className='checkmark'></span> 
                    <span>{tag.text}</span>
                  </label>
                  <i className={`fa icon-trash pull-right ${userCan('edit_contact_tag') ? '' : 'disabled'}`} onClick={() => {
                    if(userCan('edit_contact_tag')){
                      confirm(__('Proceed to delete tag?', locale))
                      .then(() => {this.props.deleteTag(index, tag.tagId, tag.text)})
                      .catch(() => {})
                    }
                  }}></i>
                  <i className={`fa icon-cog pull-right ${userCan('edit_contact_tag') ? '' : 'disabled'}`} onClick={this.toggledEdit(tag.tagId, tag.text)}></i>
                </div>}
                {toggledEdit[tag.tagId] == true && <div>
                  <input className='form-control' value={name} style={{width: '80%', display: 'inline-block'}} onChange={(e)=>{
                    this.setState({name: e.target.value})
                  }} />
                  <i className='fa icon-ok pull-right' style={{lineHeight: '30px'}} onClick={() => {
                    this.props.editTag(index, tag.tagId, tag.text, {tag_name: name}, this.toggledEdit(tag.tagId))
                  }}></i>
                  <i className='fa icon-cancel pull-right' style={{lineHeight: '30px'}} onClick={this.toggledEdit(tag.tagId, tag.text)}></i>
                </div>}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}


export default TagsField



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/TagsField.js